export const backEndMessages = {
  "INVALID_TRANSITION: TM:": {
    pt: "Formato inválido na transição da Máquina de Turing. Certifique-se de usar o formato 'leitura/escrita direção' (ex: 1/1 D).",
    en: "Invalid Turing Machine transition format. Make sure to use 'read/write direction' format (e.g., 1/1 R).",
  },
  "INVALID_DIRECTION: TM:": {
    pt: "Direção inválida na transição da Máquina de Turing. Use apenas R ou D (Direita), L ou E (Esquerda) ou S (Parado).",
    en: "Invalid direction in Turing Machine transition. Use only R or D (Right), L or E (Left), or S (Stay).",
  },
  "INVALID_TRANSITION: LBA:": {
    pt: "Formato inválido na transição do Autômato Linear Limitado.",
    en: "Invalid Linear Bounded Automaton transition format.",
  },
  "INVALID_DIRECTION: LBA:": {
    pt: "Direção inválida na transição do Autômato Linear Limitado. Use apenas R ou D (Direita), L ou E (Esquerda).",
    en: "Invalid direction in Linear Bounded Automaton transition. Use only R or D (Right), L or E (Left).",
  },
  "INVALID_TRANSITION: PDA:": {
    pt: "Formato inválido na transição do Autômato de Pilha. Certifique-se de usar o formato 'leitura desempilha/empilha' (ex: a λ/X).",
    en: "Invalid Pushdown Automaton transition format. Make sure to use 'read pop/push' format (e.g., a λ/X).",
  },
  "INVALID_TRANSITION: FSA:": {
    pt: "Formato inválido na transição do Autômato Finito. Certifique-se de usar o formato 'leitura' (ex: a).",
    en: "Invalid Finite Automaton transition format. Make sure to use 'read' format (e.g., a).",
  },
  "DEFAULT_BAD_REQUEST:": {
    pt: "Erro na estrutura do autômato. Verifique as transições e estados.",
    en: "Error in the automaton structure. Check the transitions and states.",
  },
  details: { pt: "Detalhes: ", en: "Details: " },
};
